export var CryptoTransactionStatusEnum;
(function (CryptoTransactionStatusEnum) {
    CryptoTransactionStatusEnum["SUBMITTED"] = "submitted";
    CryptoTransactionStatusEnum["COMPLETED"] = "completed";
    CryptoTransactionStatusEnum["FAILED"] = "failed";
    CryptoTransactionStatusEnum["REJECTED"] = "rejected";
})(CryptoTransactionStatusEnum || (CryptoTransactionStatusEnum = {}));
//# sourceMappingURL=crypto-transaction-status.enum.js.map